import React, { useState } from 'react'
import { createPortal } from 'react-dom'

import { ToastContext } from './ToastContext'
import Toast from './Toast'
import { StyledFlexWrapper } from './styled'
import { ToastProps } from './Toast.types'

function generateUEID() {
  const first = (Math.random() * 46656) | 0
  const second = (Math.random() * 46656) | 0
  const firstLine = ('000' + first.toString(36)).slice(-3)
  const secondLine = ('000' + second.toString(36)).slice(-3)

  return firstLine + secondLine
}

const ToastProvider = ({
  backgroundColor = 'overlay95',
  color = 'white',
  placement = 'bottom',
  width = 'fit-content',
  height = 'fit-content',
  duration = 3000,
  zIndex = 99,
  ...props
}: ToastProps & {
  children: React.ReactNode
}) => {
  const CONTAINER_TYPE = ['bottom', 'bottom-left', 'bottom-right', 'top', 'top-left', 'top-right']
  const [toasts, setToasts] = useState([])
  const open = (param) => {
    const params = {
      backgroundColor,
      color,
      placement,
      width,
      height,
      duration,
      zIndex,
      ...props,
      ...param,
    }
    setToasts((currentToasts) => [...currentToasts, { id: generateUEID(), params }])
  }
  const close = (id) =>
    setToasts((currentToasts) => currentToasts.filter((toast) => toast.id !== id))

  return (
    <ToastContext.Provider value={open}>
      {props.children}

      {CONTAINER_TYPE.map((place, index) => {
        return createPortal(
          <StyledFlexWrapper placement={place} key={place + index} zIndex={zIndex}>
            {toasts.map((toast) => {
              if (toast?.params?.placement === place)
                return <Toast key={toast.id} close={() => close(toast.id)} {...toast.params} />
            })}
          </StyledFlexWrapper>,
          document?.body,
        )
      })}
    </ToastContext.Provider>
  )
}

export default ToastProvider
